export const texts = {
  es: {
    interactiveBrokers: {
      title: "Algo salió mal",
      description:
        "No pudimos procesar tu solicitud. Por favor, intentá nuevamente.",
      footer:
        "Si el error persiste, contactate con soporte@allariasecurities.com",
      button: "Reintentar",
    },
  },
  en: {
    interactiveBrokers: {
      title: "Something went wrong",
      description: "We failed to process your request. Please try again.",
      footer: "If the error persists, contact soporte@allariasecurities.com",
      button: "Retry",
    },
  },
};
